import { IconButton, Typography } from '@mui/material'

import { LabraToolTip, TextInput } from '@labrav/react-components'

import { InfoOutlined } from '@mui/icons-material'
import { useStyles } from './RecipientsGCP.styles'
import React, { useEffect, useState } from 'react'

import clsx from 'clsx'
import { getRandom } from '../../../../../../common/utils/helperFunctions'
import { FormikProps, useFormikContext, FieldArray } from 'formik'
import { PrivateOffer } from '../../../../../../modules/privateOffer/reducer'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'
import { AddUpdateButton } from '@labrav/marketplace'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleXmark } from '@fortawesome/pro-regular-svg-icons'
import { get } from 'lodash'

export const RecipientsGCP = React.memo(() => {
  const { values, errors, touched, handleBlur, handleChange } =
    useFormikContext() as FormikProps<PrivateOffer>
  const { classes } = useStyles()
  const [randomKey, setRandomKey] = useState<number>(getRandom())
  const offerRecipients = values.offerRecipients || []

  useEffect(() => {
    setRandomKey(getRandom())
  }, [offerRecipients.length])

  return (
    <>
      <div
        className={clsx(
          classes.subHeadingContainer,
          classes.companyDetailSubHead
        )}
        style={{ marginTop: '48px' }}
      >
        <Typography
          className={classes.subHeading}
          data-testid="details-subheading-offer-recipient"
        >
          Offer recipients
        </Typography>
        <LabraToolTip
          tooltipPlacement={'right'}
          label={
            'Enter details of the person who should view and accept the offer. All offer recipients will receive offer details on email.'
          }
        >
          <InfoOutlined className={classes.infoIcon} />
        </LabraToolTip>
      </div>
      <div
        className={classes.recipientsRowsContainer}
        data-testid="update-recipients"
      >
        <FieldArray name="offerRecipients">
          {({ push, remove }) => (
            <>
              {offerRecipients.map((recipient, index) => (
                <div className={classes.updateRow} data-testid="recipient-row">
                  <div
                    key={`recipient-${randomKey}-firstName`}
                    style={{ width: '22.3%' }}
                  >
                    <TextInput
                      placeHolder=""
                      isRequired={false}
                      isReadOnly={false}
                      keyName={`offerRecipients.${index}.firstName`}
                      onChange={handleChange}
                      type="string"
                      title="First name"
                      value={recipient.firstName}
                      isError={
                        !!(
                          get(
                            touched,
                            `offerRecipients.${[index]}.firstName`,
                            false
                          ) &&
                          get(
                            errors,
                            `offerRecipients.${[index]}.firstName`,
                            false
                          )
                        )
                      }
                      errorText={
                        (!!get(
                          touched,
                          `offerRecipients.${[index]}.firstName`,
                          false
                        ) &&
                          get(
                            errors,
                            `offerRecipients.${[index]}.firstName`,
                            ' '
                          )) ||
                        ' '
                      }
                      onBlur={handleBlur}
                      variant="regularV2"
                      supportingText=" "
                    />
                  </div>
                  <div
                    key={`recipient-${randomKey}-lastName`}
                    style={{ width: '22.3%' }}
                  >
                    <TextInput
                      placeHolder=""
                      isRequired={false}
                      isReadOnly={false}
                      keyName={`offerRecipients.${index}.lastName`}
                      onChange={handleChange}
                      type="string"
                      title="Last name"
                      value={recipient.lastName}
                      isError={
                        !!(
                          get(
                            touched,
                            `offerRecipients.${[index]}.lastName`,
                            false
                          ) &&
                          get(
                            errors,
                            `offerRecipients.${[index]}.lastName`,
                            false
                          )
                        )
                      }
                      errorText={
                        (!!get(
                          touched,
                          `offerRecipients.${[index]}.lastName`,
                          false
                        ) &&
                          get(
                            errors,
                            `offerRecipients.${[index]}.lastName`,
                            ' '
                          )) ||
                        ' '
                      }
                      onBlur={handleBlur}
                      variant="regularV2"
                      supportingText=" "
                    />
                  </div>
                  <div
                    key={`recipient-${randomKey}-title`}
                    style={{ width: '22.3%' }}
                  >
                    <TextInput
                      placeHolder=""
                      isRequired={false}
                      isReadOnly={false}
                      keyName={`offerRecipients.${index}.title`}
                      onChange={handleChange}
                      type="string"
                      title="Title"
                      value={recipient.title}
                      isError={
                        !!(
                          get(
                            touched,
                            `offerRecipients.${[index]}.title`,
                            false
                          ) &&
                          get(errors, `offerRecipients.${[index]}.title`, false)
                        )
                      }
                      errorText={
                        (!!get(
                          touched,
                          `offerRecipients.${[index]}.title`,
                          false
                        ) &&
                          get(
                            errors,
                            `offerRecipients.${[index]}.title`,
                            ' '
                          )) ||
                        ' '
                      }
                      onBlur={handleBlur}
                      variant="regularV2"
                      supportingText=" "
                    />
                  </div>
                  <div
                    key={`recipient-${randomKey}-email`}
                    style={{ width: '22.3%' }}
                  >
                    <TextInput
                      placeHolder=""
                      isRequired={false}
                      isReadOnly={false}
                      keyName={`offerRecipients.${index}.email`}
                      onChange={handleChange}
                      type="string"
                      title="Email"
                      value={recipient.email}
                      isError={
                        !!(
                          get(
                            touched,
                            `offerRecipients.${[index]}.email`,
                            false
                          ) &&
                          get(errors, `offerRecipients.${[index]}.email`, false)
                        )
                      }
                      errorText={
                        (!!get(
                          touched,
                          `offerRecipients.${[index]}.email`,
                          false
                        ) &&
                          get(
                            errors,
                            `offerRecipients.${[index]}.email`,
                            ' '
                          )) ||
                        ' '
                      }
                      onBlur={handleBlur}
                      variant="regularV2"
                      supportingText=" "
                    />
                  </div>
                  {offerRecipients.length > 1 ? (
                    <div>
                      <IconButton
                        className={classes.closeIconButton}
                        onClick={() => remove(index)}
                        data-testid="cancel-button"
                        size="large"
                      >
                        <FontAwesomeIcon
                          icon={faCircleXmark}
                          width={'16px'}
                          height={'18px'}
                        />
                      </IconButton>
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              ))}

              <div
                className={classes.addButtonContainer}
                style={{ marginTop: '16px' }}
              >
                <AddUpdateButton
                  label={'Add offer recipient'}
                  onClick={() =>
                    push({
                      email: '',
                      firstName: '',
                      lastName: '',
                      title: '',
                    })
                  }
                  disabled={false}
                  icon={AddCircleOutlineIcon}
                  type={'add'}
                />
              </div>
            </>
          )}
        </FieldArray>
      </div>
    </>
  )
})
